module.exports = __webpack_public_path__ + "static/ellai-7a16a34519e09036a7790ce73c8b4e11.jpg";